export const CapacityAnalysisType = {
    CAPACITY_ANALYSIS: 'CAPACITY_ANALYSIS',
    PERFORMED_CAPACITY_ANALYSIS: 'PERFORMED_CAPACITY_ANALYSIS',
};
